module.exports = __webpack_public_path__ + "27a08e967646ee5281114491f2e18e4b.png";